<template>
  <div>
    <div v-if='bgShow' style="height:1000px"></div>
    <div class="section-content-box" v-show='isShow'>
      <el-image class="ask-icon" :src="imgUrl" style="width:1000px"></el-image>
      <div class="box-button" v-if='isShow'>
        <div class="button2 animate" @click='toBazaar'>立即升级高级版 <i class="el-icon-right"></i></div>
      </div>
      <div class="box-button2" v-if='isShow'>
        <div class="button2 animate" @click='toBazaar'>立即升级高级版 <i class="el-icon-right"></i></div>
      </div>
      <div class="box-button3" v-if='isShow'>
        <div class="button2 animate" @click='toBazaar'>立即升级高级版 <i class="el-icon-right"></i></div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "",
  props: {
    isShow: {
      type: Boolean,
      default: false,  
    },
  },
  data() {
    return {
      imgUrl: require('@/assets/images/double222.png'),
      bgShow: true,
      // imgUrl: '',
    }
  },
  created() {
    // if(!this.isShow) {
    //   this.imgUrl = ''
    // }
    setTimeout(() => {
      this.bgShow = false
    }, 150);
  },
  methods: {
    toBazaar() {
      window.open('https://fuwu.taobao.com/ser/detail.htm?spm=a1z13.pc_search_result.1234-fwlb.5.e7225acaKM1vkV&service_code=ts-131195&tracelog=search&from_key=%E4%BA%91%E7%9F%AD%E4%BF%A1')
    }
  }
}
</script>
<style lang="scss" scoped>
.section-content-box {
  background-color: #fff;
  /*box-shadow: 0 8px 20px rgba(139, 156, 188, 0.16);*/
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  padding: 10px 16px 60px 16px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  min-height: calc(100vh - 160px);
  position: relative;
  text-align: center;
}
.box-button{
  left: calc(50% - 439px);
  top: 348px;
}
.box-button2{
  left: calc(50% - 100px);
  top: 2685px;
}
.box-button3{
  left: calc(50% - 100px);
  bottom: 30px;
}
.box-button,.box-button2,.box-button3 {
  position: absolute;
  div{
    display: inline-block;
    width: 200px;
    height: 44px;
    line-height: 42px;
    text-align: center;
    border-radius: 22px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
  }
}
.box-button2,.box-button3{
  .button2{
    box-shadow: 2px 5px 5px rgba(254,96,81,0.2);
  }
}
.button1{
  background-color: #FFFFFF;
  color: #FE6654;
  // border: 1px solid #FE6654;
  margin-right: 10px;
}
.button2{
  background-image: linear-gradient(to right, #FCA06F , #FF333D);
  color: #FFFFFF;
  // border: 1px solid #FE6654;
}
.animate {
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-name: breathe;
  -webkit-animation-duration: 500ms;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-direction: alternate;
}
@-webkit-keyframes breathe {
  0% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes breathe {
  0% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@-moz-keyframes breathe {
  0% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@-o-keyframes breathe {
  0% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>